import { User } from "../types";

// MB-1491: subordinate to Developer Testing Mode (simulatePosting) - the api
// guard requires BOTH flags. With the parent off the UI disables the switch but
// never clears the stored value, so an admin sees what re-arms when it returns.
export interface ContentSimulationToggleState {
    checked: boolean;
    disabled: boolean;
}

export const deriveContentSimulationToggle = (
    user: Pick<User, "simulatePosting" | "simulateContentGeneration">
): ContentSimulationToggleState => ({
    checked: user.simulateContentGeneration ?? false,
    disabled: !user.simulatePosting,
});
